$(document).ready(() => {

    $('#form-change-background')
        .on('file-autoupload:ok', (evt, data) => {
            $('img.hero-image').attr('src',data.url);
            $('.hero input[type="file"]').val('');
            updateAccountSetup();
        })
        .on('file-autoupload:error', (evt, data) => alert(data.responseJSON.error));

    $('#form-change-picture')
        .on('file-autoupload:ok', (evt, data) => {
            $('figure.profile').css('background-image',`url(${data.url})`);
            $('figure.profile').removeClass('no-photo');
            $('figure.profile').addClass('has-photo');
            $('.header-user-image > img').attr('src', data.url);

            $('figure.profile input[type="file"]').val('');
            updateAccountSetup();
        })
        .on('file-autoupload:error', (evt, data) => alert(data.responseJSON.error));

    let $editProfileModal = $('#editProfileModal'),
        $showProfileProgress = $('#progressModal');

    $editProfileModal
        .on('show.bs.modal', () => {
            $.get($editProfileModal.data('url'), (res) => {
                $editProfileModal.find('.step-content').html(res.html);
                let title = $editProfileModal.find('.step-content form').data('title');
                $editProfileModal.find('.title').text(title);
            });
        })
        .on('hidden.bs.modal', () => {
            //window.location.reload()
        })
        .on('submit', 'form', (evt) => {

            evt.preventDefault();

            let $form = $(evt.target);
            let editDataSuccess = (res) => {
                $('#user-data').html(res.html);
                $editProfileModal.modal('toggle');
            };
            let editDataError = (res) => $('.step-content').html(res.responseJSON.html);

            ajaxSubmitForm($form, editDataSuccess, editDataError);

    });

    $showProfileProgress
        .on('show.bs.modal', () => {
            let profileProgress = $('#profile-progress').html();
            $showProfileProgress.find('.step-content').html(profileProgress);
            $showProfileProgress.find('.title').text('Profile progress');
        });

    let updateAccountSetup = () => {
        $.ajax({
            type: 'get',
            url: '/profile/account-setup-progress',
            statusCode: {
                200: (res) => $('#account-setup').closest('.white-container').replaceWith('<div class="white-container">'+res.html+'</div>'),
                400: (res)=> console.log(res.responseJSON)
            },
            dataType: 'json'
        });
    };

    let on200 = (res, $form) => {
        $form.closest('.collapse').find('.alert').remove();
        let div = $('<div>').addClass('alert alert-success').html('saved');
        $form.closest('.collapse').prepend(div.fadeOut(2500));
        updateAccountSetup();
    };

    let on400 = (res, $form) => {
        $form.closest('.collapse').find('.alert').remove();
        let responseErrors = res.responseJSON.errors;
        let errors = [];
        for(let key in responseErrors) errors.push(responseErrors[key]);
        let div = $('<div>').addClass('alert alert-warning').html(errors.join("<br>"));
        $form.prepend(div);
    };

    let on200notAccordion = (res, $form) => {
        $form.find('.alert').remove();
        let div = $('<div>').addClass('alert alert-success').html('saved');
        $form.find('h2').after(div.fadeOut(2500));
        updateAccountSetup();
    };


    let $formSpecialties = $('#form-specialties');
    $formSpecialties.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formSpecialties, on200notAccordion, ()=>{});
    });

    let $formCategories = $('#form-categories');
    $formCategories.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formCategories, on200notAccordion, ()=>{});
    });

    let $formSkills = $('#form-skills');
    $formSkills.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formSkills, on200notAccordion, ()=>{});
    });

    let $formCaption = $('#form-caption');
    $formCaption.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formCaption, on200, on400);
    });

    let $formOverview = $('#form-overview');
    $formOverview.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formOverview, on200, on400);
    });

    let $formVideo = $('#form-video');
    $formVideo.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formVideo, on200, on400);
    });

    let $formSocial = $('#form-social');
    $formSocial.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formSocial, on200, on400);
    });

    let $formDefaultPayment = $('#form-credit-cards');
    $formDefaultPayment.on('submit', function (evt) {
        evt.preventDefault();
        ajaxSubmitForm($formDefaultPayment, ()=>{}, ()=>{});
    });


    /* Accordion Forms */

    let initForms = () => {
        $('.btn-add-form').off('click').on('click', addAccordionForm);

        $('.accordion-form').each((key, form) => {
            $(form).off('submit').on('submit', submitAccordionForm);
        });
    };

    let submitAccordionForm = function (evt) {
        evt.preventDefault();
        let $form = $(evt.target);
        let callbackOK = (res) => {
            $form.closest('.collapse').find('.alert').remove();
            let div = $('<div>').addClass('alert alert-success').html('saved');
            $form.closest('.collapse').prepend(div.fadeOut(2500));

            $form.closest('.card-body').html(res.html);
            initForms();
            updateAccountSetup();

        };
        ajaxSubmitForm($(this), callbackOK, on400);
    };

    let addAccordionForm = function () {
        let url = $(this).data('url');
        $.get(url,(res) =>{
            $(this).closest('.card-body').append(res.html);
            $(this).remove();
            initForms();
        },'json');
    };


    $skillsSelect = $('select[name="skills[]"]');
    $skillsSelect.on('change', () => $('#skills-count').html($skillsSelect.val().length));

    initForms();

    $('a.cbtn-icon.icon-notification').click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $('.Header-user .notifications-container').css('visibility', 'visible');
            $('.Header-user .messages-container').css('visibility', 'hidden');
            $('a.icon-messages').removeClass('active');
            if ($(this).hasClass('unread')) {
                $(this).removeClass('unread');
                $.ajax({
                    type: 'post',
                    url: '/read-notifications',
                    statusCode: {
                        200: (res) => {
                            $('.Header-user .notifications-container ul.notifications li.notification-container').removeClass('active');
                            $('#notifications-count').remove();
                        }
                    },
                });
            }
        }
        else {
            $('.Header-user .notifications-container').css('visibility', 'hidden');
        }
        $(this).toggleClass('active');

    });

    $('a.icon-messages').click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $('.Header-user .messages-container').css('visibility', 'visible');
            $('.Header-user .notifications-container').css('visibility', 'hidden');
            $('a.cbtn-icon.icon-notification').removeClass('active');
            if ($(this).hasClass('unread')) {
                $(this).removeClass('unread');
                $.ajax({
                    type: 'post',
                    url: '/read-notifications',
                    statusCode: {
                        200: (res) => {
                            $('.Header-user .messages-container ul.notifications li.notification-container').removeClass('active');
                        }
                    },
                });
            }
        }
        else {
            $('.Header-user .messages-container').css('visibility', 'hidden');
        }
        $(this).toggleClass('active');

    });

    if($('#profile-status').data('profile-status') === 'active'){
        $('.profile-progress').css('display', 'flex');
    }

    $(document).on('click','body, body *',function(){
        if (($(this).closest('.Header').length || $(this).hasClass('Header'))) {
            return !($(this).hasClass('icon-notification') || $(this).closest('.icon-notification').length > 0 || $(this).hasClass('icon-messages') || $(this).closest('.icon-messages').length > 0);
        }
        if (!$(this).closest('.Header').length) {
            $('.Header-user .notifications-container').css('visibility', 'hidden');
            $('.Header-user .messages-container').css('visibility', 'hidden');
            $('a.cbtn-icon.icon-notification').removeClass('active');
            $('a.cbtn-icon.icon-messages').removeClass('active');
        }
    });

    /* Basic Info */

    $('.mobile-phone-inputs').on('keyup', function () {

            let $input = $(this);
            if($input.attr('id') !== 'digit4'){
                $input.next().focus();
            }else{
                let code = $('#digit1').val() + $('#digit2').val() + $('#digit3').val() + $('#digit4').val();
                $('input[name="verification-code"]').val(code)
            }
    });


    $('#form-resend-anchor').on('click', function() { $('#form-resend').trigger('submit') });

    $('#form-clear-anchor').on('click', function() { $('#form-clear').trigger('submit') });

    // Message edit
    $('#messages .message-list').on('click', '.message-btn', function () {
        let messageEditOptions = $(this).siblings('.message-edit-options');
        messageEditOptions.toggleClass('active');
    });

    $(document).on('click',function(e){
        if (!$(e.target).closest('.message-edit-options').length && !$(e.target).hasClass('message-edit-options') && !$(e.target).hasClass('message-btn')) {
            $('.message-edit-options').removeClass('active');
        }
    });

    //Show verification modal
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const success = urlParams.get('show_validation_success');
    if (success === "true") {
        $('#success-modal').modal('show');
    }

    //Favorites Switch
    $('.favorites-switch').on('click', function () {
        $('.favorites-switch span').toggleClass('active');
        $('.favorites-section').toggleClass('active');
    });

    //Toggle Progress Details
    $('.right-sidebar.private-profile').on('click', '.toggle-progress-details', function () {
        $(this).toggleClass('active');
        $('.step-content').toggleClass('active');
    })

    //Select Membership
    $('.membership-card .cbtn').on('click', function () {
        $('.membership-card').removeClass('active');
        $(this).closest('.membership-card').addClass('active');
    });
    $('#membership_renovation').on('change', function () {
        if ($(this).is(':checked')) {
            $('.membership-yearly').addClass('active');
            $('.membership-monthly').removeClass('active');
        } else {
            $('.membership-yearly').removeClass('active');
            $('.membership-monthly').addClass('active');
        }
    });
    $('input:radio[name="membership_type"]').on('change', function () {
        if ($(this).val() === 'free') {
            $('.plan-card-free').addClass('active');
           $('.plan-card-premium').removeClass('active');
        } else if ($(this).val() === 'premium') {
            $('.plan-card-free').removeClass('active');
            $('.plan-card-premium').addClass('active');
        }
    });


    //Select Payment Option
    $('input:radio[name="payment-option"]').on('change', function () {
        if ($(this).val() === 'yearly') {
            $('.payment-card-yearly').addClass('active');
            $('.payment-card-yearly .cbtn-radio').addClass('active');
            $('.payment-card-monthly').removeClass('active');
            $('.payment-card-monthly .cbtn-radio').removeClass('active');
        } else if ($(this).val() === 'monthly') {
            $('.payment-card-yearly').removeClass('active');
            $('.payment-card-yearly .cbtn-radio').removeClass('active');
            $('.payment-card-monthly').addClass('active');
            $('.payment-card-monthly .cbtn-radio').addClass('active');
        }
    });

    // Expert My-profile - Inputs State
    $('#form-personal-info').find('input, textarea').each(function () {
        if ($(this).val() !== '') {
            $(this).siblings('.cradio').addClass('completed');
        } else {
            $(this).siblings('.cradio').removeClass('completed');
        }
        $(this).on('input', function () {
            if ($(this).val() !== '') {
                $(this).siblings('.cradio').addClass('completed');
            } else {
                $(this).siblings('.cradio').removeClass('completed');
            }
        });
    });

    $('#form-categories').find('select').each(function () {
        $(this).find('option').each(function () {
            if ($(this).is(':selected')) {
                $(this).closest('.left-padding').siblings('.cradio').addClass('completed');
                return false;
            } else {
                $(this).closest('.left-padding').siblings('.cradio').removeClass('completed');
            }
        });
        $(this).on('change', function () {
            $(this).find('option').each(function () {
                if ($(this).is(':selected')) {
                    $(this).closest('.left-padding').siblings('.cradio').addClass('completed');
                    return false;
                } else {
                    $(this).closest('.left-padding').siblings('.cradio').removeClass('completed');
                }
            });
        });
    });

    // $('#form-categories').find('input[type="checkbox"]').each(function () {
    //     if ($(this).is(":checked")) {
    //         $(this).closest('.left-padding').siblings('.cradio').addClass('completed');
    //     } else {
    //         $(this).closest('.left-padding').siblings('.cradio').removeClass('completed');
    //     }
    // });

    // $('#form-categories').find('input[type="checkbox"]').on('change', function () {
    //     $('#form-categories').find('input[type="checkbox"]').each(function () {
    //         if ($(this).is(":checked")) {
    //             $(this).closest('.left-padding').siblings('.cradio').addClass('completed')
    //              return false;
    //         } else {
    //             $(this).closest('.left-padding').siblings('.cradio').removeClass('completed');
    //         }
    //     });
    // });

    //Promo Code
    $('#promo_code_btn').on('click', function () {
        let promoBtn = $('#select-payment-body #promo_code_btn');
        $.ajax({
            url  : '/promo-code',
            type : 'POST',
            data : {code : $('input[name="promo_code"]').val()},
            success : function(response) {
                $('.discount-text-error').remove();
                promoBtn.closest('.cform-input').removeClass('error');
                promoBtn.closest('.row').prepend('<div class="col-6"><div class="discount-text"><label><img src="'+location.origin+'/images/icons/promo-icon.png">Offer '+ $('input[name="promo_code"]').val() +' Applied.</label><span class="remove-code">Remove</span></div></div>');
                promoBtn.hide();
                $('input[name="promo_code"]').hide();
            },
            error : function (response) {
                $('.discount-text-error').remove();
                promoBtn.closest('.cform-input').addClass('error');
                promoBtn.closest('.row').append('<div class="col-12 discount-text-error"><img src="'+location.origin+'/images/icons/icon-error.svg" alt="icon error"><label class="error">Offer '+ $('input[name="promo_code"]').val() +' is not valid.</label></div>');
            }
        });
    })

    $('#select-payment-body').on('click', '.remove-code', function () {
        $('.discount-text').closest('.col-6').remove();
        $('input[name="promo_code"]').val('').show();
        $('#promo_code_btn').show();
    });
});
